module.exports = __webpack_public_path__ + "img/logo.35b89b5f.png";